module.exports = __webpack_public_path__ + "static/media/driver-rear-preview.20483fc7.svg";